import React, { useEffect, useState } from "react";
import { Typography, Popover } from "antd";
import { useIntl } from "react-intl";
import { ClockCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import { useServiceTypes } from "../../hooks";
const { Text } = Typography;

const PartialOrderTooltip = (props) => {
  const { order, events } = props;
  const intl = useIntl();
  const [name, setName] = useState(null);

  const orderEvents = events
    ? events.filter((i) => i.order_id === order.id)
    : [];
  const serviceTypes = useServiceTypes();

  useEffect(() => {
    const selected = serviceTypes
      ? serviceTypes.filter((item) => item.id === order.service_type)[0]
      : null;
    if (selected) {
      setName(selected["name"]);
    }
  }, [serviceTypes, order.service_type]);

  const employeesEvents = Object.values(
    orderEvents.reduce((acc, event) => {
      const { employee_id, employee, duration_minutes, approved } = event;
      const { first_name, surename } = employee || {};
      const durationInMinutes = duration_minutes || 0;

      if (!acc[employee_id]) {
        acc[employee_id] = {
          employee_id,
          first_name,
          surename,
          approved_hours: 0,
          total_hours: 0,
        };
      }

      acc[employee_id].total_hours =
        Math.round(
          (acc[employee_id].total_hours + durationInMinutes / 60) * 100
        ) / 100;
      if (approved) {
        acc[employee_id].approved_hours =
          Math.round(
            (acc[employee_id].approved_hours + durationInMinutes / 60) * 100
          ) / 100;
      }

      return acc;
    }, {})
  );
  const content = (
    <div>
      {order.max_hours && (
        <div>
          <Text>{`${name} ${order.max_hours}`}</Text>
          <br />
        </div>
      )}
      <Text>{`${intl.formatMessage({
        id: "app.orders.effective_from",
      })}: ${moment(order.effective_from).format("DD/MM/YYYY")}`}</Text>
      <br />
      {order.effective_to && (
        <Text>{`${intl.formatMessage({
          id: "app.orders.effective_to",
        })}: ${moment(order.effective_to).format("DD/MM/YYYY")}`}</Text>
      )}
      {events && orderEvents?.length > 0 && (
        <>
          <div style={{ paddingTop: "10px" }}>
            <Text className="ant-popover-title">{`${intl.formatMessage({
              id: order.is_day_center
                ? "app.orders.schedulings"
                : "app.orders.employee_schedulings",
            })}`}</Text>
            <br />
          </div>
          {employeesEvents.map((i) =>
            i.employee_id ? (
              <div>
                <Text>{`${i.surename} ${i.first_name}: ${i.approved_hours}/${i.total_hours}`}</Text>
              </div>
            ) : (
              <div>
                <Text>{`${i.approved_hours}/${i.total_hours}`}</Text>
              </div>
            )
          )}
        </>
      )}
    </div>
  );

  return (
    <Popover
      content={content}
      title={intl.formatMessage({
        id: "app.orders.orderDetails",
      })}
    >
      <ClockCircleOutlined style={{ padding: "0 5px", color: "red" }} />
    </Popover>
  );
};

export default PartialOrderTooltip;
